import React from 'react'
import {MutateVoyageViewContext} from "../ViewContextProviderMutateSingleVoyage";

export const useViewContextMutateSingleVoyage = () => React.useContext(MutateVoyageViewContext)